import React from 'react';
import SiteHeader from './SiteHeader.js';
import GamesButtons from './GamesButtons.js';

export default function MainPage(){
  return (
    <div>
        <div>
            <SiteHeader />
             <GamesButtons />
        </div>
    </div>
  )
}
